/* Produktkennzeichnung (SKU/GTIN) in der Zeile "Sicherheitshinweise".
 *
 * WOZU: Das Theme rendert bei einem Variantenwechsel INNERHALB desselben Produkts
 * nicht die ganze Section neu. In assets/variant-picker.js entscheidet das
 * `shouldMorphMain`-Argument von `fetchUpdatedSection()`, und das ist auf der
 * Produktseite `loadsNewProduct` - also nur dann wahr, wenn ein anderes Produkt
 * geladen wird (Combined Listing). Beim normalen Umschalten laeuft stattdessen
 * `updateVariantPicker(html)`, und alle uebrigen Bausteine (Preis, Bestand,
 * Titel, Badge) holen sich ihren neuen Stand selbst aus dem Event.
 *
 * Genau dieses Muster bildet diese Datei nach - Vorbild ist assets/product-title.js.
 *
 * BEWUSST OHNE import: product-title.js laedt `ThemeEvents` aus "@theme/events",
 * das braucht einen Eintrag in der Importmap in layout/theme.liquid. Diese Datei
 * benutzt stattdessen den Ereignisnamen als Zeichenkette. Er ist in
 * assets/events.js festgelegt:
 *     static variantUpdate = "variant:update";
 * Aendert Shopify den Namen, bleibt die Nummer stehen - sie wird nicht falsch.
 * Dafuer ist keine Datei im Theme-Kern anzufassen.
 *
 * Das Ereignis blubbert (events.js: `super(ThemeEvents.variantUpdate, { bubbles: true })`),
 * deshalb genuegt ein Zuhoerer auf der Section.
 * Die Nutzlast ist `event.detail.data.html` - ein vollstaendiges Document, weil
 * `buildRequestUrl()` auf der Produktseite `produkt-url?option_values=...` abruft
 * (ohne `section_id`, das gibt es nur im Quick-Add).
 *
 * SEIT 22.08.2026: die Kennzeichnung steht in einer EIGENEN Akkordeon-Zeile
 * ("Produktdaten"), nicht mehr unten in der Zeile "Sicherheitshinweise". Am
 * Austauschverfahren aendert das nichts - das Markup ist identisch, es steht nur
 * woanders. Neu ist einzig `data-eigene-zeile`: gehoert die Zeile ganz uns, wird
 * sie mitversteckt, wenn eine Variante weder SKU noch GTIN hat. Sonst bliebe ein
 * leerer Aufklapper "Produktdaten" stehen. Heute trifft das kein aktives Produkt
 * (alle 6.995 fuehren eine SKU); die Wache steht fuer den Tag, an dem sich das
 * aendert.
 */

(function () {
  if (window.customElements && customElements.get("lbrgt-produktkennzeichnung")) return;

  class LbrgtProduktkennzeichnung extends HTMLElement {
    #section = null;

    connectedCallback() {
      // In Produktkacheln (Quick-Add) hat der Block nichts zu suchen - dort gibt es
      // ihn heute nicht, aber die Pruefung kostet nichts und verhindert Doppelarbeit.
      if (this.closest("product-card")) return;

      const section = this.closest(".shopify-section, dialog");
      if (!section) return;

      this.#section = section;
      section.addEventListener("variant:update", this.aktualisieren);
    }

    disconnectedCallback() {
      if (this.#section) {
        this.#section.removeEventListener("variant:update", this.aktualisieren);
        this.#section = null;
      }
    }

    aktualisieren = (event) => {
      const daten = event && event.detail && event.detail.data;
      const html = daten && daten.html;
      if (!html) return;

      // Bei einem Produktwechsel (Combined Listing) wandert die Kennung mit;
      // sonst nur reagieren, wenn es wirklich um dieses Produkt geht.
      if (daten.newProduct) {
        this.dataset.productId = daten.newProduct.id;
      } else if (daten.productId && this.dataset.productId && daten.productId !== this.dataset.productId) {
        return;
      }

      // Es kann mehrere Bloecke geben (z. B. eine zweite Sicherheitszeile in einer
      // anderen Vorlage). Ueber die Block-ID die richtige Quelle finden.
      const blockId = this.dataset.blockId;
      let quelle = null;

      if (blockId) {
        const kandidaten = html.querySelectorAll("lbrgt-produktkennzeichnung");
        for (let i = 0; i < kandidaten.length; i++) {
          if (kandidaten[i].dataset.blockId === blockId) {
            quelle = kandidaten[i];
            break;
          }
        }
      }
      if (!quelle) quelle = html.querySelector("lbrgt-produktkennzeichnung");

      // Neue Variante ohne SKU und ohne GTIN: der Block fehlt in der Antwort.
      // Dann die alten Nummern LEEREN, nicht stehen lassen - eine falsche Nummer
      // ist schlimmer als gar keine. Gehoert uns die ganze Zeile, verschwindet
      // sie mit - ein Aufklapper "Produktdaten" ohne Daten waere schlimmer als
      // gar keine Zeile.
      if (!quelle) {
        if (this.innerHTML !== "") this.innerHTML = "";
        this.#zeileZeigen(false);
        return;
      }

      if (this.innerHTML !== quelle.innerHTML) {
        this.innerHTML = quelle.innerHTML;
      }
      this.#zeileZeigen(true);
    };

    // Nur die eigene Zeile darf versteckt werden. Steht die Kennzeichnung in
    // der Hersteller-Zeile, wuerde das sonst die GPSR-Pflichtangabe ausblenden.
    #zeileZeigen(sichtbar) {
      if (this.dataset.eigeneZeile !== "true") return;
      const zeile = this.closest("[data-lbrgt-kennzeichnung-zeile]");
      if (!zeile) return;
      zeile.hidden = !sichtbar;
    }
  }

  if (window.customElements) {
    customElements.define("lbrgt-produktkennzeichnung", LbrgtProduktkennzeichnung);
  }
})();
